import React from 'react';
import { t } from 'i18next';
import ArtisticIcon from './riasec/ArtisticIcon';
import EnterprisingIcon from './riasec/EnterprisingIcon';
import InvestigativeIcon from './riasec/InvestigativeIcon';
import RealisticIcon from './riasec/RealisticIcon';
import SocialIcon from './riasec/SocialIcon';
import ConventionalIcon from './riasec/ConventionalIcon';
import { riasecScoreCopy } from '../../../copy/user-dashboard/riasec-score-copy.json';

export default class BarGroupHorizontal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  showIcon = (label, xOffsetProp, yOffset) => {
    const { tablet } = this.props;
    const xOffset = tablet ? xOffsetProp - 4 : xOffsetProp;
    switch (label) {
      case riasecScoreCopy.labels[0].name:
        return (
          <RealisticIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      case riasecScoreCopy.labels[1].name:
        return (
          <InvestigativeIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      case riasecScoreCopy.labels[2].name:
        return (
          <ArtisticIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      case riasecScoreCopy.labels[3].name:
        return (
          <SocialIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      case riasecScoreCopy.labels[4].name:
        return (
          <EnterprisingIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      case riasecScoreCopy.labels[5].name:
        return (
          <ConventionalIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      default:
        return (
          <ArtisticIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
    }
  };

  renderBar = (item, thickness, index, yVal) => {
    const yLabelVal = yVal + 15;
    const nameLabelOffset = 70;
    const iconOffset = 10;
    const barColour = index < 3 ? this.props.tenant.primary : '#C1C1C1';
    const lengthScale = (d) => d * 15;
    const length = lengthScale(item.value);
    const midpoint = thickness * 0.5;

    return (
      <g className="bar-group">
        <text
          className={this.props.tablet ? 'name-label tablet' : 'name-label'}
          x={midpoint}
          y={yVal + nameLabelOffset}
          alignmentBaseline="middle"
        >
          {t(item.name)}
        </text>
        <rect
          data-cy={`${item.name.replace(/\(|\)/g, '').replace(' ', '')}-rect`}
          y={yVal - length}
          height={length}
          width={thickness}
          fill={barColour}
        />
        {this.showIcon(item.name, 0, yVal + iconOffset)}
        <text
          data-cy={`${item.name.replace(/\(|\)/g, '').replace(' ', '')}-value`}
          className="value-label"
          x={midpoint}
          y={yLabelVal - length}
          alignmentBaseline="middle"
        >
          {item.value}
        </text>
      </g>
    );
  };

  barGroups = (items, thicc, spacing) => {
    const margin = this.props.tablet ? 22 : 35;
    const yVal = 148;
    return items.map((item, index) => (
      <g
        key={item.name}
        transform={`translate( ${margin + index * spacing}, ${yVal})`}
      >
        {this.renderBar(item, thicc, index, yVal)}
      </g>
    ));
  };

  render() {
    const { data, thickness, spacing } = this.props;
    return this.barGroups(data, thickness, spacing);
  }
}
